import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { NotificationToast } from "../../../../../components/Generic/Toast/NotificationToast";
import { useAppState } from "../../../../../context/StateContext";
import { UserProject } from "../../../../../models/user.project";
import { UserProjectService } from "../../../../../services/user.project.service";
import {
  BookingKeys,
  ContainerKeys,
  DespatchKeys,
  PurchaseOrderKeys,
  ShipmentKeys,
  UserProjectKeys,
} from "../../../../../util/queries";

export const useActionNetwork = () => {
  const { currentUser, setCurrentUser } = useAppState();
  const { t: translate } = useTranslation();
  const queryClient = useQueryClient();

  const useUserProjectViewUpdate = () => {
    return useMutation({
      mutationKey: UserProjectKeys.updateProjectView(),
      mutationFn: ({ userProjects }: { userProjects: UserProject[] }) =>
        UserProjectService.updateProjectView(userProjects),
      onSuccess: (response) => {
        NotificationToast.success(translate("operationPerformedSuccessfully"));

        const userProjects = response.data;

        if (currentUser) {
          setCurrentUser({
            ...currentUser,
            projects: [
              ...currentUser.projects.map((project) => {
                const currentUserProject = userProjects.find(
                  (userProject) => userProject.projectId === project.id
                );

                if (currentUserProject) {
                  return {
                    ...project,
                    projectView: !!currentUserProject?.projectView,
                  };
                }

                return project;
              }),
            ],
          });
        }
        queryClient.invalidateQueries({ queryKey: [BookingKeys.all] });
        queryClient.invalidateQueries({ queryKey: [DespatchKeys.all] });
        queryClient.invalidateQueries({ queryKey: [ShipmentKeys.all] });
        queryClient.invalidateQueries({ queryKey: [ContainerKeys.all] });
        queryClient.invalidateQueries({ queryKey: [PurchaseOrderKeys.all] });
      },
    });
  };

  return {
    useUserProjectViewUpdate,
  };
};
